// extracted by mini-css-extract-plugin
export default {"wrap":"LeadPaginator_wrap__fEYKZ","dark":"LeadPaginator_dark__YjtJC","btn":"LeadPaginator_btn__Nk7wl","counter":"LeadPaginator_counter__1eQxW"};